export const CANONICAL_COLLECTIONS = [
  'users',
  'body_data',
  'exercise_logs',
  'daily_goals',
  'calendar_events',
  'timetable',
  'homework',
  'exams',
  'grades',
  'custom_subjects',
  'subject_files',
  'flashcard_decks',
  'flashcards',
  'notes',
  'user_settings',
] as const

export type CanonicalCollection = (typeof CANONICAL_COLLECTIONS)[number]

export const COLLECTION_ALIASES: Record<string, CanonicalCollection> = {
  note: 'notes',
  notes: 'notes',
  event: 'calendar_events',
  events: 'calendar_events',
  calendar: 'calendar_events',
  workout: 'exercise_logs',
  workouts: 'exercise_logs',
  goal: 'daily_goals',
  goals: 'daily_goals',
  deck: 'flashcard_decks',
  decks: 'flashcard_decks',
  flashcard: 'flashcards',
  flashcards: 'flashcards',
  setting: 'user_settings',
  settings: 'user_settings',
}

const KNOWN_COLLECTIONS = new Set<string>(CANONICAL_COLLECTIONS)

export function normalizeCollectionInput(input: string): string {
  return input.trim().toLowerCase()
}

export function resolveCanonicalCollection(input: string): string {
  const normalized = normalizeCollectionInput(input)
  if (!normalized) return ''

  if (KNOWN_COLLECTIONS.has(normalized)) {
    return normalized
  }

  return COLLECTION_ALIASES[normalized] || normalized
}
